export default __webpack_public_path__ + "static/media/showcase.4d2e284d.svg";